module.exports = __webpack_public_path__ + "inst.svg?28dfc2056216f373338d0d26279f0655";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/inst.svg
// module id = 75
// module chunks = 0